export default function ENTP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “مجادله&zwnj;گر”</h1>{" "}
          <blockquote>
            <p>
              مسیر ناامن متفکری مستقل را دنبال کنید. ایده&zwnj;های خود را در
              معرض خطر اختلاف نظر قرار دهید. نظرات خود را بیان کنید و از برچسب
              "احمق بودن" کمتر بترسید تا از ننگ همرنگ شدن با جماعت. و در خصوص
              مسائلی که برایتان مهم است، به هر قیمتی که شده از آنها دفاع کنید.
            </p>{" "}
            <footer>Thomas J. Watson</footer>
          </blockquote>{" "}
          <p>
            گونه شخصیتی مجادله&zwnj;گر به&zwnj;راستی وکیل مدافع شیطان است، یعنی
            نابود کردن استدلال&zwnj;ها و اعتقادات و در معرض دید همگان قرار دادن
            حاصل این تلاش. مجادله&zwnj;گران بر خلاف شخصیت&zwnj;های مصمم&zwnj;تر،
            این کار را به این دلیل انجام نمی&zwnj;دهند که می&zwnj;خواهند به هدفی
            عمیق&zwnj;تر یا استراتژیک برسند، بلکه فقط به این دلیل ساده چنین کاری
            را می&zwnj;کنند که برایشان سرگرم&zwnj;کننده است. هیچ&zwnj;کس به
            اندازه مجادله&zwnj;گران نبرد ذهنی را دوست ندارد، چرا که این کار به
            آنها فرصتی برای به&zwnj;کار بستن شوخ طبعی خود بدون اینکه به زحمت
            بیفتند، نشان دادن دانش گسترده خود و ظرفیت ربط دادن ایده&zwnj;های
            پراکنده برای اثبات حرفشان را می&zwnj;دهد.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              تناقض غریبی در مورد مجادله&zwnj;گران رخ می&zwnj;دهد زیرا آنها
              واقعاً صادق هستند، اما به&zwnj;طور خستگی&zwnj;ناپذیر برای اثبات
              چیزهایی استدلال می&zwnj;کنند که در واقع به آنها باور ندارند یعنی
              پای خود را در کفش دیگران می&zwnj;کنند تا در مورد یک حقیقت از منظری
              دیگر استدلال نمایند.
            </p>
          </blockquote>{" "}
          <p>
            ایفای نقش وکیل مدافع شیطان به افراد دارای گونه شخصیتی مجادله&zwnj;گر
            کمک می&zwnj;کند تا نه تنها درک بهتری از استدلال دیگران کسب کنند،
            بلکه درک بهتری از عقاید مخالف بیابند - چرا که مجادله&zwnj;گران هستند
            که در تأیید چنین عقیده&zwnj;هایی استدلال می&zwnj;کنند.
          </p>{" "}
          <p>
            این تاکتیک را نباید با نوعی از درک متقابل اشتباه گرفت که
            گونه&zwnj;های شخصیتی گروه نقش دیپلمات به دنبال آن است -
            مجادله&zwnj;گران دائماً در حال تلاش برای کسب دانش هستند و برای کسب
            دانش چه راهی بهتر از حمله به یک ایده و دفاع از آن از هر زاویه و از
            هر طرف وجود دارد؟
          </p>{" "}
          <div className="scene"></div>{" "}
          <h2>
            در اینجا هیچ قانونی وجود ندارد - ما داریم تلاش می&zwnj;کنیم کاری را
            به انجام برسانیم.
          </h2>{" "}
          <p>
            مجادله&zwnj;گران که تا حدودی از اینکه طرف شکست&zwnj;خورده بحث باشند
            لذت می&zwnj;برند، عاشق تمرین ذهنی به پرسش کشیدن نظام غالب اندیشه،
            بی&zwnj;ارزش کردن آنها در حین بازسازی نظام&zwnj;های موجود یا به هم
            ریختن امور و طرح آنها به شیوه&zwnj;هایی تازه هستند. با این حال از
            توضیح روال معمول اجرای پیشنهادهای خود در عالم واقع عاجز هستند.
            شخصیت&zwnj;های مجادله&zwnj;گر عاشق این هستند که "ایده آفرینی" کنند و
            افکار بزرگی داشته باشند، اما از اینکه به هر قیمتی گرفتار انجام
            "کارهای سنگین" شوند، پرهیز می&zwnj;کنند. مجادله&zwnj;گران تنها حدود
            سه درصد از جمعیت را تشکیل می&zwnj;دهند که هیچ اشکالی هم ندارد زیرا
            می&zwnj;توانند ایده&zwnj;های اصیلی را پدید بیاورند، سپس کنار بکشند و
            اجازه بدهند شخصیت&zwnj;های رایج&zwnj;تر و سختکوش&zwnj;تر زحمت
            تدارکات مربوط به اجرا و نگهداری را بکشند.
          </p>{" "}
          <p>
            توانایی مجادله&zwnj;گران برای بحث می&zwnj;تواند آزاردهنده باشد -
            زیرا اگرچه وقتی افراد خواستار استفاده از این توانایی باشند از آن
            قدردانی نیز می&zwnj;کنند، اما ممکن است به وضعیت&zwnj;های
            عذاب&zwnj;آوری نیز منتهی شود مثلاً وقتی چنین افرادی با زیر سؤال بردن
            نظرات رئیس خود در یک جلسه یا گزینش مهمترین نکاتی که دیگران
            گفته&zwnj;اند، موجبات رنجش آنها را فراهم کنند. قضیه وقتی
            پیچیده&zwnj;تر می&zwnj;شود که بدانیم مجادله&zwnj;گران ذاتاً صداقت
            دارند زیرا این گونه افراد کلمات را خوب به هم نمی&zwnj;آمیزند و اهمیت
            چندانی نمی&zwnj;دهند که افرادی دلسوز یا مهربان تلقی شوند. افرادی که
            ذهنیت مشابهی با گونه شخصیتی مجادله&zwnj;گر داشته باشند با آن کنار
            می&zwnj;آیند، اما اغلب اوقات گونه&zwnj;های شخصیتی حساس&zwnj;تر و
            به&zwnj;طور کلی جامعه، از مناقشه گریزان هستند و احساسات، آسایش و حتی
            دروغ&zwnj;های مصلحتی را به حقایق ناخوشایند و عقلانیت سفت و سخت ترجیح
            می&zwnj;دهند.
          </p>{" "}
          <p>
            این امر باعث دلسردی مجادله&zwnj;گران می&zwnj;شود زیرا وقتی سرگرم زیر
            و رو کردن عقاید دیگران و زیر پا گذاشتن احساساتشان هستند
            درمی&zwnj;یابند که راه بسیاری از مجادلات سرگرم&zwnj;کننده&zwnj;شان -
            اغلب به&zwnj;طور سهوی - بر روی آنها بسته می&zwnj;شود.
            مجادله&zwnj;گران وقتی با خودشان همان رفتاری می&zwnj;شود که با دیگران
            داشته&zwnj;اند، از اینکه از پاسخ دادن به سؤالاتشان طفره بروند،
            به&zwnj;خصوص وقتی خواهشی را مطرح کنند، ناراحت خواهند شد.
            شخصیت&zwnj;های مجادله&zwnj;گر به دلیل نگرش، اعتماد به نفس، دانش و حس
            شوخ&zwnj;طبعی مورد احترام قرار می&zwnj;گیرند، اما اغلب در تلاش برای
            استفاده از همین ویژگی&zwnj;ها به عنوان مبنایی برای دوستی&zwnj;های
            عمیق&zwnj;تر و روابط عاشقانه دچار مشکل می&zwnj;شوند.
          </p>{" "}
          <h2>فرصت از دست می&zwnj;رود چرا که کار دشواری به نظر می&zwnj;رسد</h2>{" "}
          <p>
            مجادله&zwnj;گران برای مهار توانایی&zwnj;های طبیعی خود نسبت به دیگران
            راه درازتری در پیش دارند - استقلال فکری و چشم&zwnj;انداز باز آنها
            فوق&zwnj;العاده ارزشمند است به&zwnj;خصوص وقتی مسئول انجام کاری باشند
            یا حداقل کسی که مسئول است از آنها حرف&zwnj;شنوی داشته باشد، اما
            انجام عملی کارها نیازمند مقداری پیگیری است که افراد دارای گونه
            شخصیتی مجادله&zwnj;گر نمی&zwnj;توانند از پس آن برآیند.
          </p>{" "}
          <p>
            مجادله&zwnj;گران پس از اینکه جایگاه خود را مستحکم کردند، باید به
            خاطر داشته باشند که برای اینکه ایده&zwnj;هایشان به ثمر بنشیند، همیشه
            برای کنار هم چیدن بخش&zwnj;های آن به دیگران وابسته هستند - چنانچه
            مجادله&zwnj;گران بخش زیادی از وقت خود را صرف "پیروز شدن" در مباحثات
            کنند تا ایجاد اجماع، در نهایت پشتیبانی لازم را برای موفق شدن در
            اختیار نخواهند داشت. افراد دارای این گونه شخصیتی به این دلیل که نقش
            وکیل مدافع شیطان را به&zwnj;خوبی ایفا می&zwnj;کنند، ممکن است متوجه
            شوند که پیچیده&zwnj;ترین و باارزش&zwnj;ترین چالش فکری درک
            دیدگاه&zwnj;های احساساتی&zwnj;تر، و استدلال در خصوص ملاحظات و سازش
            در کنار منطق و پیشرفت است.
          </p>
        </article>
      </div>
    </div>
  );
}
